import { lazy } from "react";

const LoadableMarkdown = lazy(
  () =>
    import(/* webpackChunkName: "MarkdownComponent" */ "./MarkdownComponent")
);

export default LoadableMarkdown;
